import { Routes, Route, Navigate, Link } from "react-router-dom";
import { CallFlow } from "../features/call/CallFlow";
import { Schedule } from "../features/schedule/Schedule";
import { AdminConsole } from "../features/admin/AdminConsole";
import { AvailabilityToggle } from "../features/workspace/AvailabilityToggle";
import { LanguageToggle } from "../i18n/LanguageToggle";
import { useI18n } from "../i18n/localization";

// Standalone shell — full navigation (login + officer workspace + admin console).
// docs/design/05-uiux-spec.md §4 + §6. The officer workspace (home) mounts CallFlow so
// the traffic officer receives incoming calls over the hub.

export function StandaloneShell() {
  const { t, dir } = useI18n();
  return (
    // Self-contained viewport-height flex chain (see EmbeddedShell) so the layout also
    // holds if the launch page renders this shell top-level without the extracted CSS.
    // Matches the .vc-shell rule, so the static index.html flow is unaffected.
    <div
      className="vc-shell vc-shell--standalone"
      style={{ height: "100dvh", flex: 1, minHeight: 0, display: "flex", flexDirection: "column", overflow: "hidden" }}
    >
      <header style={{ background: "#14305f", color: "#fff", padding: "10px 18px", display: "flex", alignItems: "center", flex: "0 0 auto" }}>
        <strong>{t.app.policeBrand}</strong>
        <nav style={{ marginInlineStart: "auto", fontSize: 13, display: "flex", gap: 12, alignItems: "center" }}>
          <Link to="/" style={{ color: "#c4d2ea" }}>{t.nav.home}</Link>
          <Link to="/schedule" style={{ color: "#c4d2ea" }}>{t.nav.schedule}</Link>
          <Link to="/admin" style={{ color: "#c4d2ea" }}>{t.nav.admin}</Link>
          <AvailabilityToggle />
          <LanguageToggle />
        </nav>
      </header>
      {/* Routed content fills the height left by the header; min-height:0 lets the in-call
          screen shrink to fit while taller pages (schedule/admin/directory) scroll here. */}
      <div style={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column", overflow: "auto" }}>
        <Routes>
          <Route path="/" element={<CallFlow />} />
          <Route path="/schedule" element={<Schedule />} />
          <Route path="/login" element={<Placeholder name="login" dir={dir} />} />
          <Route path="/admin/*" element={<AdminConsole />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </div>
  );
}

function Placeholder({ name, dir }: { name: string; dir: "rtl" | "ltr" }) {
  const { t } = useI18n();
  return (
    <main dir={dir} style={{ padding: 24, fontFamily: "Segoe UI, Arial, sans-serif" }}>
      <h1 style={{ color: "#14305f", fontSize: 18 }}>{name}</h1>
      <p style={{ color: "#5b6b82", fontSize: 13 }}>
        {t.nav.placeholder}{" "}
        <code>docs/design/05-uiux-spec.md</code>.
      </p>
    </main>
  );
}
